import { Pipe, PipeTransform } from '@angular/core';
import { parseVehicleAge } from '../utils/parse-vehicle-age.util';
import { AGE_OPERATORS } from 'src/app/modules/contracts/consts/age-operators-options.const';
import { Option } from '../models/option.interface';

@Pipe({
  name: 'vehicleAge'
})
export class VehicleAgePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';
    const vehicleAge = parseVehicleAge(value);
    const operatorInWords: string = AGE_OPERATORS
        .find((option: Option) => option.key === vehicleAge.operator)?.name ?? '';
    return operatorInWords + ' ' + vehicleAge.years;
  }

}